import React from 'react'
import _ from 'underscore'

class GoogleMap extends React.Component {

  componentDidMount() {
    if (!this.props.loaded) {
      window.setTimeout(
        () => { this.props.store.emit('ui:google_map:load')},
        100
      )
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.latitude !== this.props.latitude)
      return true

    if (nextProps.longitude !== this.props.longitude)
      return true

    if (nextProps.markers !== this.props.markers)
      return true

    if (nextProps.loaded !== this.props.loaded)
      return true

    return false
  }

  render() {
    if (this.props.loaded)
      return (
        <LoadedMap
          latitude={this.props.latitude}
          longitude={this.props.longitude}
          markers={this.props.markers}
        />
      )
    else
      return (
        <UnloadedMap/>
      )
  }
}

class UnloadedMap extends React.Component {

  render() {
    return (
      <div className="h-[600px] w-full overflow-hidden rounded-md border border-border">
        <div className="size-full"></div>
      </div>
    )
  }
}

class LoadedMap extends React.Component {

  constructor(props) {
    super(props)

    this.map = null
    this.map_markers = []
    this.mapCanvasRef = React.createRef()
  }

  componentDidMount() {
    this.map = this.createMap()
    this.map_markers = this.createMarkers()
  }

  componentDidUpdate() {
    this.destroyMarkers()
    this.map.setCenter(new google.maps.LatLng(this.props.latitude, this.props.longitude), 15)
    this.map_markers = this.createMarkers()
  }

  createMap() {
    const options = {
      zoom: 14,
      center: new google.maps.LatLng(this.props.latitude, this.props.longitude),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      draggable: true,
      disableDefaultUI: true,
      zoomControl: true,
      streetViewControl: true,
      scrollwheel: false
    }

    return (new google.maps.Map(this.mapCanvasRef.current, options))
  }

  destroyMarkers() {
    _.each(this.map_markers, function(marker) {
      marker.setMap(null)
    })

    this.map_markers = []
  }

  createMarkers() {
    this.destroyMarkers()

    return _.map(this.props.markers, (marker) => {
      const map_marker = new google.maps.Marker({map: this.map, position: new google.maps.LatLng(marker.latitude, marker.longitude)})
      const infowindow = new google.maps.InfoWindow({content: marker.content})
      google.maps.event.addListener(map_marker, 'click', () => { infowindow.open(this.map, map_marker)})

      if (marker.open) {
        infowindow.open(this.map, map_marker)
      }

      return map_marker
    })
  }

  render() {
    return (
      <div className="h-[600px] w-full overflow-hidden rounded-md border border-border">
        {/* Map tiles must escape preflight's `img { max-width: 100% }`. */}
        <div className="size-full [&_img]:max-w-none! [&_img]:[background:none]!" ref={this.mapCanvasRef}></div>
      </div>
    )
  }
}

export {GoogleMap, UnloadedMap, LoadedMap}
